module.exports = __webpack_public_path__ + "img/zz-row-one.a45f8208.svg";